var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Button } from "../../button";
import { Typo } from "../../typography";
import { useFocusVisible } from "use-focus-visible";
import { StyledMaskInput, StyledDateInputWithIcon, StyledInputWrapper, } from "./date-input.styles";
export const Input = (_a) => {
    var { onFocus, onBlur, onIconClick, onReset, onValueChange, value, label, withIcon, error, disabled, readonly, withSeconds, hideDatePicker, required } = _a, props = __rest(_a, ["onFocus", "onBlur", "onIconClick", "onReset", "onValueChange", "value", "label", "withIcon", "error", "disabled", "readonly", "withSeconds", "hideDatePicker", "required"]);
    const [selected, setSelected] = useState(false);
    const { focusVisible, onFocus: onFocused, onBlur: onBlured, } = useFocusVisible();
    const myRef = useRef(null);
    const activeElement = typeof window !== "undefined" ? document.activeElement : null;
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            hideDatePicker();
        }
    };
    useEffect(() => {
        const button = myRef.current.querySelector("button");
        if (button) {
            button.addEventListener("blur", () => {
                setSelected(false);
            });
            return () => {
                button.removeEventListener("blur", () => {
                    setSelected(false);
                });
            };
        }
        return () => { };
    }, [activeElement]);
    useEffect(() => {
        setSelected(myRef.current.contains(activeElement));
    }, [activeElement]);
    const className = `${readonly ? "readonly" : ""}`;
    return (_jsxs(StyledDateInputWithIcon, Object.assign({ withSeconds: withSeconds, ref: myRef }, { children: [label && (_jsxs(Typo, Object.assign({ variant: "label2" }, { children: [label, label && required && "*"] }))), _jsxs(StyledInputWrapper, { children: [_jsx(StyledMaskInput, Object.assign({}, props, { value: value, error: error, onChange: (e) => {
                            if (typeof onValueChange === "function")
                                onValueChange(e.currentTarget.value);
                        }, selected: selected, focusVisible: focusVisible, onBlur: (e) => {
                            if (typeof onBlur === "function")
                                onBlur(e);
                            onBlured();
                        }, onFocus: (e) => {
                            if (typeof onFocus === "function")
                                onFocus(e);
                            setSelected(true);
                            onFocused();
                        }, onKeyDown: handleKeyDown, size: props.mask.length, className: className, disabled: disabled })), value && !readonly ? (_jsx(Button, { stylingType: "flat", onClick: () => {
                            if (typeof onReset === "function")
                                onReset();
                            onValueChange("");
                        }, isIcon: true, symbol: "Close" })) : (withIcon &&
                        !readonly && (_jsx(Button, { disabled: disabled, stylingType: "flat", onClick: onIconClick, isIcon: true, symbol: "Clock" })))] }), error && (_jsx(Typo, Object.assign({ className: "error-msg", variant: "label2" }, { children: error })))] })));
};
